import { BoxProps, Box, Body, Icon } from '@hover/blueprint';
import { iChevronDown } from '@hover/icons';
import React, { FC, useState } from 'react';
import { IDropdownItem } from '../../../interfaces/IDropdownItem';

interface Props extends BoxProps {
  width?: string | number;
  items: IDropdownItem[];
  onSelectItem: (item: IDropdownItem) => void;
}

const Dropdown: FC<Props> = props => {
  const { width, items, onSelectItem, ...rest } = props;

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<IDropdownItem | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const onChange = (item: IDropdownItem) => {
    setSelected(item);
    onSelectItem(item);
    toggleDropdown();
  };

  return (
    <Box
      position="relative"
      borderWidth="1px"
      borderColor="neutral.300"
      w={width}
      maxH="265px"
      px="16px"
      py="12px"
      my="24px"
      borderRadius="4px"
      onClick={toggleDropdown}
      {...rest}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        w="100%"
      >
        {selected ? (
          <Body size={500} isBold>
            {selected.value}
          </Body>
        ) : (
          <Body size={300} isBold>
            STATE
          </Body>
        )}
        <Icon icon={iChevronDown} />
      </Box>
      <Box
        display={isOpen ? 'flex' : 'none'}
        flexDir="column"
        alignItems="flex-start"
        position="absolute"
        boxShadow="0px 16px 32px 0px #0000002E"
        top="56px"
        left={0}
        w="100%"
        px="32px"
        py="16px"
        backgroundColor="white"
        zIndex={10}
        borderRadius="4px"
      >
        <Body size={500} color="primary.900" lineHeight="32px">
          Select your state
        </Body>
        {items.map(item => (
          <Body
            onClick={() => {
              onChange(item);
            }}
            key={item.key}
            size={500}
            color="primary.900"
            lineHeight="32px"
          >
            {item.value}
          </Body>
        ))}
      </Box>
    </Box>
  );
};

Dropdown.defaultProps = {
  width: '100%',
};

export default Dropdown;
